import { LoadingButton } from '@mui/lab';
import { Box, Button, Stack, Typography } from '@mui/material';
import OperationProductCard from 'components/shared/operation/OperationProductCard/OperationProductCard';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';

const AgentTaskCard = ({
  task,
  canMutate,
  actionLoading,
  onRunTask,
  onRemoveTask,
}) => {
  const isPreView = task.status === 'PreView';

  return (
    <OperationProductCard
      product={task}
      canMutate={canMutate}
      actionLabel={isPreView ? 'ارسال' : undefined}
      onAction={isPreView ? onRunTask : undefined}
      actionDisabled={actionLoading}
    >
      {canMutate && isPreView ? (
        <LoadingButton
          size="small"
          color="error"
          variant="contained"
          loading={actionLoading}
          onClick={() => onRemoveTask?.(task.guid)}
          sx={{ mt: 0.5 }}
        >
          حذف وظیفه
        </LoadingButton>
      ) : null}
    </OperationProductCard>
  );
};

export const AgentDetail = ({
  agent,
  tasks = [],
  detailLoading = false,
  canMutate = false,
  actionLoading = false,
  onRunTask,
  onRunAllTasks,
  onRemoveTask,
  onDeleteAgent,
}) => {
  if (detailLoading) {
    return <SpinnerLoader />;
  }
  const allTasksDone = tasks.every(task => task.status === 'Done');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
      >
        <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
          <Typography variant="body2" fontWeight={600}>
            {tasks.length}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            وظیفه
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          {canMutate ? (
            <>
              {tasks.length === 0 && (
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  disabled={actionLoading}
                  onClick={() =>
                    onDeleteAgent?.(agent.operationAgentGuid || agent.guid)
                  }
                >
                  حذف انباردار
                </Button>
              )}
              {!allTasksDone && (
                <LoadingButton
                  size="small"
                  variant="contained"
                  loading={actionLoading}
                  disabled={!tasks.length}
                  onClick={() => onRunAllTasks?.(agent.guid)}
                >
                  ارسال همه
                </LoadingButton>
              )}
            </>
          ) : null}
        </Stack>
      </Stack>

      {!tasks.length ? (
        <Box
          sx={{
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography color="text.secondary">
            وظیفه‌ای برای این PDA ثبت نشده است.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              xl: 'repeat(4, 1fr)',
            },
            gap: 2,
          }}
        >
          {tasks.map(task => (
            <AgentTaskCard
              key={task.guid}
              task={task}
              canMutate={canMutate}
              actionLoading={actionLoading}
              onRunTask={onRunTask}
              onRemoveTask={onRemoveTask}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
